var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(_vm.currentLoadingComponent, {
    tag: "component",
    attrs: { "data-qa": "mini-wizard-skeleton" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }